import * as React from "react";

// Laufwerk AI (Branding beim Deployment, deploy/branding/logo/build_assets.py)
const SvgDustLogoSquare = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 100 100",
  ...props
}, /*#__PURE__*/React.createElement("rect", {
  width: "100",
  height: "100",
  rx: "24",
  fill: "#14284B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 22 h14 v42 h30 a7 7 0 0 1 0 14 h-37 a7 7 0 0 1 -7 -7 z",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70 22 l3.5 8.5 l8.5 3.5 l-8.5 3.5 l-3.5 8.5 l-3.5 -8.5 l-8.5 -3.5 l8.5 -3.5 z",
  fill: "#14B8A6"
}));
export default SvgDustLogoSquare;
//# sourceMappingURL=DustLogoSquare.js.map